// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Krqy","content":"styles_content__2-vLg"};